﻿import React from 'react';
import { Menu, MenuProps } from "@mui/material";
import { styled } from "@mui/styles";

const Root = styled(Menu)(() => ({
  '& .MuiPopover-paper': {
    boxShadow: '0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
  }
}));

type ActionsMenuProps = MenuProps;

const ActionsMenu = ({ children, ...rest }: ActionsMenuProps) => {
  return <Root keepMounted {...rest}>
    { children }
  </Root>
}

export { ActionsMenu };